import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import './css/register.css';

function Login() {
  const { handleLogin } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const onSubmit = (e) => {
    e.preventDefault();
    handleLogin({ email, password });
  };

  return (
    <div className="container">
      <div className="form-container">
        <h2 className="form-title">INICIAR SESION</h2>
        <form onSubmit={onSubmit}>
          <div className="input-container">
            <label className="label" htmlFor="email">Email</label>
            <input
              className="input"
              id="email"
              type="email"
              placeholder="       Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-container">
            <label className="label" htmlFor="password">Contraseña</label>
            <input
              className="input"
              id="password"
              type="password"
              placeholder="       Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit">Login</button>
        </form>
        <p className="footer-form">
          ¿No tienes cuenta? <Link to="/register" className="link">Registrarse</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
